import { render, staticRenderFns } from "./InstancesList.vue?vue&type=template&id=b803c8be&"
import script from "./InstancesList.vue?vue&type=script&lang=js&"
export * from "./InstancesList.vue?vue&type=script&lang=js&"
import style0 from "./InstancesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports